import { CssType, ThemeType } from 'src/theme/jss-types';

export const CalculationDetailsDrawerStyles = (theme: ThemeType): CssType => ({
  headerContainer: {
    padding: '16px 20px',
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #F0F0F0',
    marginBottom: '0',
  },
  gridContainer: {
    display: 'flex',
    gap: '16px 10%',
    marginBottom: '8px',
    flexWrap: 'wrap',
  },
  item: {
    alignItems: 'baseline',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    color: '#262626',
    fontWeight: 400,
    minWidth: 'fit-content',
  },
  value: {
    fontSize: '14px',
    color: '#000',
    fontWeight: 600,
    wordBreak: 'break-word',
  },
  bodyContainer: {
    display: 'flex',
    height: 'calc(100vh - 250px)',
    minHeight: '400px',
    overflow: 'hidden',
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  tabsContainer: {
    height: 'calc(100vh - 250px)',
    overflowY: 'auto',
    padding: '20px',
  },
  tabsContainerNoPadding: {
    height: '100%',
    overflowY: 'auto',
    padding: 0,
  },
  tabs: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
